/** Stable per-document key for UI prefs (zoom, pan, active page, etc.). */
export function getDocumentPrefsKey(fileId?: string | null, fileName?: string | null): string {
  // Prefer the visible file name: server fileIds are ephemeral (new on each upload and
  // after page mutations), so keying prefs by fileId breaks restore on reload/re-upload.
  const base = (fileName || fileId || 'global').trim();
  return base.replace(/[^a-z0-9._-]/gi, '_').slice(0, 80) || 'global';
}